module.exports = __webpack_public_path__ + "media/images/ceremony/top/reason4-401f859542f35dd5c5952651ff537f71.jpg";